import {Columns} from '@shared/interfaces/table/column-config';
import {datahubPartial} from '@shared/partials/datahub.partial';
import {AggregatedWholeSaleDto} from '@app/api/dmc';
import {DateCellComponent} from '@shared/components/table/cells/date-cell/date-cell.component';
import {businessReasonCodePartial} from '@shared/partials/business-reason-code.partial';
import {resolutionPartial} from '@shared/partials/resolution.partial';
import {productIdentificationPartial} from '@shared/partials/product-identification.partial';
import {unitTypePartial} from '@shared/partials/unit-type.partial';
import {meteringPointTypePartial} from '@shared/partials/meteringpointtype-partial.table';
import {settlementmethodPartial} from '@shared/partials/settlementmethod.partial';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const settlementWholesaleMasterdata: Columns<AggregatedWholeSaleDto>[] = [
  datahubPartial as Columns<AggregatedWholeSaleDto>,
  {
    title: 'common.date.received',
    key: 'createdTS',
    cellRenderer: DateCellComponent
  },
  {
    title: 'common.date.start',
    key: 'startDate',
    cellRenderer: DateCellComponent
  },
  {
    title: 'common.date.end',
    key: 'endDate',
    cellRenderer: DateCellComponent
  },
  {
    title: 'settlement.wholesale.balancesupplieridentification',
    key: 'balanceSupplierIdentification'
  },
  businessReasonCodePartial as Columns<AggregatedWholeSaleDto>,
  resolutionPartial as Columns<AggregatedWholeSaleDto>,
  productIdentificationPartial as Columns<AggregatedWholeSaleDto>,
  unitTypePartial as Columns<AggregatedWholeSaleDto>,
  {
    ...meteringPointTypePartial,
    key: 'typeOfMeteringPoint',
  },
  settlementmethodPartial as Columns<AggregatedWholeSaleDto>,
  {
    title: 'settlement.wholesale.chargetype',
    key: 'chargeType',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'chargeInformation.chargeTypes.notspecified',
      subscription: 'chargeInformation.chargeTypes.subscription',
      fee: 'chargeInformation.chargeTypes.fee',
      tariff: 'chargeInformation.chargeTypes.tariff'
    }
  },
  {
    title: 'settlement.wholesale.chargeowner',
    key: 'chargeOwnerEnergyParty'
  },
  {
    title: 'common.version.title',
    key: 'version',
  }
]
